import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);
@Component({
  selector: 'app-dashboard-finance',
  templateUrl: './dashboard-finance.component.html',
  styleUrls: ['./dashboard-finance.component.scss'],
})
export class DashboardFinanceComponent implements OnInit, AfterViewInit {

  //Global Var Chart
  @ViewChild('barChart') private barChart: ElementRef;
  @ViewChild('doughnutChart') private doughnutChart: ElementRef;
  @ViewChild('lineChart') private lineChart: ElementRef;

  lineChartX: Chart;
  barChartX: Chart;
  doughnutChartX: any;

  totalDate: Date = new Date()

  //Bar Chart
  totalIncomeMonthlyChart: number = 0;
  dataProfitByFormule: number[] = [];
  profitByFormuleLabel = "";
  profitByFormuleLabelTitle: string[] = [];
  optionsProfitByFormule: any = {};
  dataLoaded1: boolean = false;
  realData1: boolean = false;
  dataDoughnut: any = {};

  //DoghnutChart
  dataMonthlyProfit: any = [];
  monthlyProfitLabel = "";
  monthlyProfitLabelTitle: string[] = [];
  optionsProfitByMonth: any = {};
  dataLoaded2: boolean = false;
  realData2: boolean = false;
  dataBar: any = {};

  //LineChart
  dataProfitEvolution: number[] = [];
  profitEvolutionLabel = "";
  profitEvolutionLabelTitle: string[] = [];
  optionsProfitEvolution: any = {};
  dataLoaded3: boolean = false;
  realData3: boolean = false;
  dataLine: any = {};



  //Date
  now: Date = new Date()
  startMonthlyDate = new Date()
  endMonthlyDate = new Date()
  IsoMonthlyDate: any
  nowString: string = this.now.toISOString();
  startDate: Date;
  endDate: Date;
  evolutionStartDate: Date;
  barDate1: string;
  barDate2: string;
  lineDate1: string;
  lineDate2: string;
  doghDate1: string;
  doghDate2: string;

  //Other
  coach: any;
  needUpdate: Boolean = false;
  totalIncome: number = 0;
  monthIncome: number = 0;
  coachId: string

  constructor(
    private userService: UserService,
    private ApiProviderService: ApiProviderService,
    private zone: NgZone,
  ) { }




  ngOnInit() {
    this.now = new Date()
    this.now.toISOString();

    this.totalDate = new Date()

    this.IsoMonthlyDate = this.endMonthlyDate.toISOString()
    //date pour chart 
    this.startDate = new Date(this.now.getFullYear(), this.now.getMonth() - 6, this.now.getDate());
    this.endDate = new Date(this.now.getFullYear(), this.now.getMonth(), this.now.getDate() + 2);
    this.barDate1 = this.startDate.toISOString();
    this.barDate2 = this.endDate.toISOString();
    this.doghDate1 = this.startDate.toISOString();
    this.doghDate2 = this.endDate.toISOString();
    // Limiter à une année au lieu de 10 ans
    this.evolutionStartDate = new Date(this.now.getFullYear() - 1, this.now.getMonth(), this.now.getDate());
    this.lineDate1 = this.evolutionStartDate.toISOString()
    this.lineDate2 = this.endDate.toISOString();

    this.startMonthlyDate = new Date(this.now.getFullYear(), this.now.getMonth(), 1);

    // Déterminer la date du dernier jour du mois en cours
    this.endMonthlyDate = new Date(this.now.getFullYear(), this.now.getMonth() + 1, 0);

    //Get the Coach
    this.coach = this.userService.getUser();
    if (this.coach) {
      this.coachId = this.coach.id;
      this.incomeTotalCaclul();
      this.getIncomeByDate(this.coachId, this.startMonthlyDate, this.endMonthlyDate)
    }
  }

  ngAfterViewInit(): void {
    //Chart First Creation
    this.zone.run(() => {
      this.getProfitsByFormuleByCoach(this.startDate, this.endDate);
      this.getProfitsByMonthByCoach(this.startDate, this.endDate)
      this.getProfitEvolutionByCoach(this.evolutionStartDate, this.endDate)
    });
  }

  //Get Total Income
  incomeTotalCaclul() {
    this.ApiProviderService.getTotalProfit(this.coachId,).subscribe(
      (res: any) => {
        this.totalIncome = res;
      },
      (err) => {
        return;
      },
    )
  }

  //Get Income By date
  getIncomeByDate(coachId, startDate, endDate) {
    this.monthIncome = 0
    this.ApiProviderService.getProfitsByMonthByCoach(coachId, startDate, endDate).subscribe(
      (res: any) => {
        if (res.length) {
          res.forEach(line => {
            this.monthIncome += line.totalAmount
          }); 
        }else{
          this.monthIncome = 0;
        }
      },
      (err) => {
        return;
      },
    )
  }

  // Méthode pour gérer le changement de date mensuelle
  MonthlyDateChange(event: CustomEvent) {
    const selectedDate = new Date(this.IsoMonthlyDate);
    const startDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
    const endDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
    this.getIncomeByDate(this.coachId, startDate, endDate);
  }

  // Function to Get Data for Chart
  //Doghnut Data
  getProfitsByFormuleByCoach(startDate: Date, endDate: Date) {

    this.dataDoughnut = []
    this.profitByFormuleLabelTitle = []
    this.dataProfitByFormule = []

    this.ApiProviderService
      .getProfitsByFormulesByCoach(this.userService.getUser().id, startDate, endDate)
      .subscribe(
        (data) => {
          if (Array.isArray(data)) {
            data.forEach(element => {
              this.dataProfitByFormule.push(element.totalProfit);
              this.profitByFormuleLabelTitle.push(element.nomFormule)
            });
            this.dataDoughnut = {
              labels: this.profitByFormuleLabelTitle,
              datasets: [{
                label: "€ Gains",
                data: this.dataProfitByFormule,
              }]
            }
            this.profitByFormuleLabel = "€ Gains"
            this.optionsProfitByFormule = {
              plugins: {
                responsive: true,
                legend: {
                  position: 'bottom', // Place les légendes à l'intérieur du camembert
                  align: 'center', // Centre les légendes horizontalement
                  labels: {
                    boxWidth: 10, // Ajustez la largeur de la case de couleur de la légende
                    fontSize: 12, // Ajustez la taille de police des légendes
                    usePointStyle: true // Utilisez les cercles au lieu des carrés pour les légendes
                  }
                },
                tooltip: {
                  // ⤵️ tooltip main styles
                  backgroundColor: '#007bff',
                  padding: 10,
                  // ⤵️ title
                  titleColor: 'white',
                  titleFont: {
                    size: 18
                  },
                  // ⤵️ body 
                  bodyColor: 'white',
                  bodyFont: {
                    size: 13
                  }
                },
              },
              maintainAspectRatio: false
            }
          }
          this.dataLoaded1 = true;

          if (this.dataProfitByFormule.some(valeur => valeur !== 0)) {
            this.realData1 = true
          }
          if (this.doughnutChartX) {
            this.doughnutChartX.destroy()
          }
          this.createChart(this.doughnutChartX, "doughnut")
        },
        (error) => {
          // Handle any errors that occurred during the API call
          console.error(error);
        }
      );
  }

  //Bar Data
  getProfitsByMonthByCoach(startDate: Date, endDate: Date) {
    this.dataMonthlyProfit = []
    this.monthlyProfitLabelTitle = []
    this.dataBar = []
    this.ApiProviderService.getProfitsByMonthFormuleByCoach(this.userService.getUser().id, startDate, endDate)
      .subscribe((data: any) => {
        if (data) {
          this.monthlyProfitLabelTitle = data[0];
          data[1].forEach(element => {
            const dataArray: { data: number[], label: string } = {
              data: element.data, // Tableau de données pour les barres empilées
              label: element.label // Label pour le dataset
            };
            this.dataMonthlyProfit.push(dataArray);

          });
          this.dataBar = {
            labels: this.monthlyProfitLabelTitle,
            datasets: this.dataMonthlyProfit.map(dataArray => ({
              label: dataArray.label,
              data: dataArray.data, // Couleur de fond pour le dataset
              borderRadius: 3,
            }))
          };
          this.monthlyProfitLabel = "€ Gains";
          this.optionsProfitByMonth = {
            scales: {
              x: {
                stacked: true,
                grid: {
                  display: false
                }
              },
              y: {
                stacked: true,
                ticks: {
                  // Include a dollar sign in the ticks
                  callback: function (value, index, ticks) {
                    return value + '€';
                  }
                },
                grid: {
                  display: false
                }
              }
            },
            plugins: {
              responsive: true,
              legend: {
                position: 'bottom', // Place les légendes à l'intérieur du camembert
                align: 'center', // Centre les légendes horizontalement
                labels: {
                  boxWidth: 10, // Ajustez la largeur de la case de couleur de la légende
                  fontSize: 12, // Ajustez la taille de police des légendes
                  usePointStyle: true // Utilisez les cercles au lieu des carrés pour les légendes
                }
              },
              tooltip: {
                // ⤵️ tooltip main styles
                backgroundColor: '#007bff',
                padding: 10,
                // ⤵️ title
                titleColor: 'white',
                titleFont: {
                  size: 18
                },
                // ⤵️ body 
                bodyColor: 'white',
                bodyFont: {
                  size: 13
                }
              },
            },
            maintainAspectRatio: false
          }

        }
        this.dataLoaded2 = true;
        if (this.dataProfitByFormule.some(valeur => valeur !== 0)) {
          this.realData2 = true
        }
        if (this.barChartX) {
          this.barChartX.destroy()
        }
        this.createChart(this.barChart, "bar");
      }, (error) => {
        // Handle any errors that occurred during the API call
        console.error(error);
      }
      );
  }

  //Line Chart
  getProfitEvolutionByCoach(startDate: Date, endDate: Date) {
    this.dataProfitEvolution = []
    this.profitEvolutionLabelTitle = []
    this.dataLine = []

    this.ApiProviderService.getProfitsByMonthByCoach(this.userService.getUser().id, startDate, endDate)
      .subscribe(
        (data: any) => {
          if (data) {
            data.forEach(element => {
              this.dataProfitEvolution.push(element.totalAmount);
              this.profitEvolutionLabelTitle.push(element.month)
            });

            this.dataLine = {
              labels: this.profitEvolutionLabelTitle,
              datasets: [{
                label: "€ Gains",
                data: this.dataProfitEvolution,
                pointHitRadius: 15, // expands the hover 'detection' area
                pointHoverRadius: 8, // grows the point when hovered
                // ⤵️ Add these
                pointRadius: 2,
                borderColor: '#0061c8',
                pointBackgroundColor: '#0061c8',
                pointHoverBackgroundColor: '#0061c8',
                borderWidth: 2, // main line width
                hoverBorderWidth: 0, // borders on points
                pointBorderWidth: 0, // removes POINT borders
                tension: 0.3, // makes line more squiggly
              }]
            }
            this.profitEvolutionLabel = "€ Gains"
            this.optionsProfitEvolution = {
              scales: {
                x: {
                  grid: {
                    display: false
                  }
                },
                y: {
                  ticks: {
                    // Include a dollar sign in the ticks
                    callback: function (value, index, ticks) {
                      return value + '€';
                    }
                  },
                  grid: {
                    display: false
                  }
                }
              },
              plugins: {
                responsive: true,
                legend: {
                  display: false,
                },
                tooltip: {
                  // ⤵️ tooltip main styles
                  backgroundColor: '#007bff',
                  displayColors: false, // removes unnecessary legend
                  padding: 10,
                  // ⤵️ title
                  titleColor: 'white',
                  titleFont: {
                    size: 18
                  },
                  // ⤵️ body 
                  bodyColor: 'white',
                  bodyFont: {
                    size: 13
                  }
                },
              },

              maintainAspectRatio: false
            }
          }
          this.dataLoaded3 = true;
          if (this.dataProfitEvolution.some(valeur => valeur !== 0)) {
            this.realData3 = true
          }
          if (this.lineChartX) {
            this.lineChartX.destroy()
          }
          this.createChart(this.lineChart, "line");
        },
        (error) => {
          // Handle any errors that occurred during the API call
          console.error(error);
        }
      );
  }

  //Change Date Event
  onbarDate1Change(event: CustomEvent) {
    this.startDate = new Date(this.barDate1)
    this.endDate.setHours(23, 59, 0)
    this.endDate.setMonth(this.endDate.getMonth() + 1)
    this.endDate.setDate(0)
    this.startDate.setHours(0, 0, 0)
    this.startDate.setDate(1)
    this.getProfitsByMonthByCoach(this.startDate, this.endDate)
  }

  onbarDate2Change() {
    this.endDate = new Date(this.barDate2)
    this.endDate.setHours(23, 59, 0)
    this.endDate.setMonth(this.endDate.getMonth() + 1)
    this.endDate.setDate(0)
    this.startDate.setHours(0, 0, 0)
    this.startDate.setDate(1)
    this.getProfitsByMonthByCoach(this.startDate, this.endDate)
  }

  onDoghDate1Change(event: CustomEvent) {
    this.startDate = new Date(this.doghDate1)
    this.endDate.setHours(23, 59, 0)
    this.endDate.setDate(31)
    this.startDate.setHours(0, 0, 0)
    this.startDate.setDate(1)
    this.getProfitsByFormuleByCoach(this.startDate, this.endDate)
  }

  onDoghDate2Change() {
    this.endDate = new Date(this.doghDate2)
    this.endDate.setHours(23, 59, 0)
    this.endDate.setDate(31)
    this.startDate.setHours(0, 0, 0)
    this.startDate.setDate(1)
    this.getProfitsByFormuleByCoach(this.startDate, this.endDate)
  }

  onlineDate1Change(event: CustomEvent) {
    this.evolutionStartDate = new Date(this.lineDate1)
    this.evolutionStartDate.setHours(0, 0, 0, 0)
    this.getProfitEvolutionByCoach(this.evolutionStartDate, this.endDate)
  }

  onlineDate2Change() {
    this.endDate = new Date(this.lineDate2)
    this.endDate.setHours(23, 59, 59, 999)
    this.getProfitEvolutionByCoach(this.evolutionStartDate, this.endDate)
  }

  //Creation and Update Chart

  createChart(nativeElement: ElementRef, type: string) {
    if (type === "line") {
      setTimeout(() => {
        const ctx = this.lineChart.nativeElement;
        this.lineChartX = new Chart(ctx, {
          type: type,
          data: this.dataLine,
          options: this.optionsProfitEvolution,
        });
      }, 300);
    }
    if (type === 'bar') {
      var chartExist = Chart.getChart("barChart");
      setTimeout(() => {
        const ctx = this.barChart.nativeElement;
        this.barChartX = new Chart(ctx, {
          type: type,
          data: this.dataBar,
          options: this.optionsProfitByMonth
        });
      }, 300);
    }

    if (type === "doughnut") {
      setTimeout(() => {
        const ctx = this.doughnutChart.nativeElement;
        this.doughnutChartX = new Chart(ctx, {
          type: type,
          data: this.dataDoughnut,
          options: this.optionsProfitByFormule
        });
      }, 300);
    }
  }

}
